<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="loading || processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar :class="$style['container-header']">
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
        <fragment v-if="resourceName === 'makers'">

          <fragment v-if="!isProvider">
          <div class="d-flex align-center">
            <v-btn
                    class="mx-1"
                    small
                    color="success"
                    max-height="36"
                    depressed
                    :class="$style['control-button']"
                    @click="onShowMakerRecipes"
                    v-if="isProvider"
            >
              登録レシピ一覧
            </v-btn>
            <v-btn
                    class="mx-1"
                    small
                    color="success"
                    max-height="36"
                    depressed
                    :class="$style['control-button']"
                    @click="onShowMakerProducts"
                    v-if="isProvider"
            >
              登録商品一覧
            </v-btn>
            <v-btn
                    class="mx-1"
                    small
                    color="success"
                    max-height="36"
                    depressed
                    :class="$style['control-button']"
                    @click="onShowMakerAdmins"
                    v-if="isProvider"
            >
              担当者情報
            </v-btn>
          </div>
          </fragment>
          <template v-else-if="isProvider">
            <CContainer style="padding: 0">
              <CRow style="padding: 3px">
                <div class="d-flex align-center">
                  <v-btn
                          class="mx-1"
                          small
                          color="success"
                          max-height="22"
                          depressed
                          :class="$style['control-button-sm']"
                          @click="onShowMakerRecipes"
                          v-if="isProvider"
                  >
                    登録レシピ一覧
                  </v-btn>
                  <v-btn
                          class="mx-1"
                          small
                          color="success"
                          max-height="22"
                          depressed
                          :class="$style['control-button-sm']"
                          @click="onShowMakerProducts"
                          v-if="isProvider"
                  >
                    登録商品一覧
                  </v-btn>
                  <v-btn
                          class="mx-1"
                          small
                          color="success"
                          max-height="22"
                          depressed
                          :class="$style['control-button-sm']"
                          @click="onShowMakerAdmins"
                          v-if="isProvider"
                  >
                    担当者情報
                  </v-btn>
                </div>
              </CRow>
              <CRow style="padding-left: 3px">
            <div class="d-flex align-center">
              <v-btn
                      class="mx-1"
                      small
                      color="success"
                      max-height="22"
                      depressed
                      :class="$style['control-button-sm']"
                      @click="openDialog('recipes')"
                      v-if="!disableImport"
              >
                レシピ一括登録
              </v-btn>
              <v-btn
                      class="mx-1"
                      small
                      color="success"
                      max-height="22"
                      depressed
                      :class="$style['control-button-sm']"
                      @click="openDialog('products')"
                      v-if="!disableImport"
              >
                商品一括登録
              </v-btn>
              <v-btn
                      class="mx-1"
                      small
                      color="success"
                      max-height="22"
                      depressed
                      :class="$style['control-button-sm']"
                      @click="moveToDownload('recipes')"
              >
                レシピ一括ダウンロード
              </v-btn>
              <v-btn
                      class="mx-1"
                      small
                      color="success"
                      max-height="22"
                      depressed
                      :class="$style['control-button-sm']"
                      @click="moveToDownload('products')"
              >
                商品一括ダウンロード
              </v-btn>
            </div>
              </CRow>
            </CContainer>
          </template>
        </fragment>
      </template>
      <template v-slot:right>
        <template v-if="resourceName === 'recipes'">
          <div class="d-flex align-center">
            <v-btn
                    class="mx-1"
                    small
                    color="success"
                    max-height="36"
                    depressed
                    :class="$style['control-button']"
                    @click="onCheckMaker"
                    v-if="isProvider"
            >
              メーカーを確認
            </v-btn>
          </div>
        </template>
        <template v-if="resourceName === 'products'">
          <div class="d-flex align-center">
            <v-btn
                  class="mx-1"
                  small
                  color="success"
                  max-height="36"
                  depressed
                  :class="$style['control-button']"
                  @click="onCheckMaker"
                  v-if="isProvider"
            >
              メーカーを確認
            </v-btn>
            <v-btn
                    class="mx-1"
                    small
                    color="success"
                    max-height="36"
                    depressed
                    :class="$style['control-button']"
                    @click="onCheckAnswer"
                    :disabled="isDisabledCheckUnserBtn"
            >
              レビュー結果を確認
            </v-btn>
          </div>
        </template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="onRefresh" v-on="on">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>再読込</span>
        </v-tooltip>
      </template>
    </ToolBar>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <div :class="$style['main-content']">
          <template v-if="loaded">
            <template v-if="error">
              <div :class="$style['container-error']">
                <p>
                  <v-icon color="red darken-2">mdi-alert-circle</v-icon>
                  <span>エラーが発生しました</span>
                </p>
                <v-btn @click="onBack">戻る</v-btn>
              </div>
            </template>
            <template v-else>
              <CCard bodyWrapper v-for="(section, index) in fields" :key="'m_' + index">
                <CContainer style="padding: 0;">
                  <CRow>
                    <CCol :lg="field.long ? 12 : 6" class="py-0"
                          v-for="(field, childIndex) in
                          section.filter((item) => {return !(item.isProvider && !isProvider)} )" :key="'c_' + childIndex">
                      <FieldGenerator
                        :key="index"
                        :value="entity[field.name]"
                        :type="field.type || 'display'"
                        :name="field.name"
                        :label="field.label"
                        :render="field.render || undefined"
                        :as="field.as"
                        :option="(value) => field.option(value, entity)"
                        :remarks="field.remarks"
                        :optionType="field.optionType"
                      >
                        <template v-if="field.type === 'custom'">
                          <template v-if="field.name === 'recipeCount'" :slot="field.name">
                            <slot :name="field.name" :input="entity" />
                          </template>
                          <template v-else-if="field.name === 'productCount'" :slot="field.name">
                            <slot :name="field.name" :input="entity" />
                          </template>
                          <template v-else-if="field.name === 'billing_history'" :slot="field.name">
                            <CButton color="success"
                              @click.stop="openCondimentsModal()">
                              課金履歴
                            </CButton>
                          </template>
                          <template v-else :slot="field.name">
                            <slot :name="field.name" :input="entity[field.name]" />
                          </template>
                        </template>
                      </FieldGenerator>
                    </CCol>
                  </CRow>
                </CContainer>
              </CCard>
            </template>
          </template>
        </div>
        <div v-if="loaded && !error && !disableEdit" :class="$style['container-footer']">
          <v-toolbar>
            <slot name="actions.update">
              <CButton
                v-if="showEditButton"
                class="mx-1"
                color="primary"
                @click="onEdit"
                :disabled="isDisabledUpdateBtn"
              >
                変更
              </CButton>
            </slot>
            <CButton
              v-if="showCheckMakerButton"
              class="mx-1"
              color="success"
              @click="onCheckMaker"
            >
              メーカーを確認する
            </CButton>
            <CButton
                    v-if="showPublishButton"
                    :disabled="entity.published_status === 1 || entity.published_status === 2"
                    class="mx-1" color="success" @click="publishModal = true">
              公開
            </CButton>
            <CButton
                    v-if="showPublishButton"
                    :disabled="entity.published_status === 0 || entity.published_status === 3"
                    class="mx-1" color="success" @click="unPublishModal = true">
              非公開
            </CButton>
            <CButton
                    v-if="showPublishButton"
                    :disabled="entity.published_status < 2"
                    class="mx-1" color="success" @click="cancelPublish">
              予約取消
            </CButton>
            <fragment v-if="resourceName === 'maker_administrators' || resourceName === 'administrators'">
              <CButton class="mx-1" color="success"
                       @click="onChangePassword">
                パスワード変更
              </CButton>
            </fragment>
            <fragment v-if="resourceName === 'questionnaires'">
              <v-btn
                class="mx-1"
                color="success"
                max-height="36"
                depressed
                :class="$style['control-button']"
                :href="entity.url"
                target="_blank"
              >
                アンケート画面
              </v-btn>
            </fragment>
            <fragment v-if="resourceName === 'topics'">
              <CButton class="mx-1" color="success"
                       @click="">
                特集ページ作成画面
              </CButton>
            </fragment>
            <fragment v-if="resourceName === 'reminders' && entity.notification_type === 2">
              <CButton class="mx-1" color="success"
                       @click="moveToHistories">
                催促履歴表示
              </CButton>
            </fragment>
            <fragment v-if="resourceName === 'reminders' && entity.notification_type === 2">
              <CButton class="mx-1" color="primary"
                       @click="onSendReminder"
                       :disabled="entity.sent !== 1 || entity.performed_status === '達成'"
              >
                アンケート催促送信
              </CButton>
            </fragment>
            <CButton class="mx-1" color="primary" v-if="showRestoreButton"
                     :disabled="disableRestoreButton"
                      @click="onRestore">
              復活
            </CButton>
            <slot name="actions.remove">
              <CButton
                v-if="showDeleteButton"
                class="mx-1"
                color="danger"
                @click="onDelete"
                :disabled="isDisableDeleteButton"
              >
                削除
              </CButton>
            </slot>
            <slot name="actions" />
          </v-toolbar>
        </div>
      </v-content>
    </div>

    <CModal
            color="success"
            :show.sync="publishModal"
            title="公開状態切替"
    >
      <p>
        公開状態を変更するタイミングを選択してください
      </p>
      <CInputRadioGroup
              style="margin-top: 10px;margin-bottom: 5px"
              :options="[
                { value: false, label: '即時'},
                { value: true, label: '予約'}
              ]"
              @update:checked="onChangeReservePublish"
      >
      </CInputRadioGroup>

      <datepicker :format="DatePickerFormat" :language="ja"
                  :class="$style['datepicker']"
                  placeholder="日付を選択してください"
                  v-if="reservePublish"
                  v-model="targetDate"
                  :disabled-dates="disableDates"
      ></datepicker>

      <v-btn
              class="mx-1"
              @click="publish(1)"
              small
              color="success"
              max-height="36"
              depressed
              :class="$style['control-button']"
      >
        公開
      </v-btn>
      <template #footer>
        <span></span>
      </template>
    </CModal>
    <CModal
            color="danger"
            :show.sync="unPublishModal"
            title="非公開状態切替"
    >
      <p>
        公開状態を変更するタイミングを選択してください
      </p>
      <CInputRadioGroup
              style="margin-top: 10px;margin-bottom: 5px"
              :options="[
                { value: false, label: '即時'},
                { value: true, label: '予約'}
              ]"
              @update:checked="onChangeReservePublish"
      >
      </CInputRadioGroup>

      <datepicker :format="DatePickerFormat" :language="ja"
                  :class="$style['datepicker']"
                  placeholder="日付を選択してください"
                  v-if="reservePublish"
                  v-model="targetDate"
                  :disabled-dates="disableDates"
      ></datepicker>

      <v-btn
              class="mx-1"
              @click="publish(0)"
              small
              color="error"
              max-height="36"
              depressed
              :class="$style['control-button']"
      >
        非公開
      </v-btn>
      <template #footer>
        <span></span>
      </template>
    </CModal>
    <CModal
            color="success"
            :show.sync="condimentsModal"
            title="課金履歴"
            hide-footer
    >
      <CDataTable
              :fields="[
                { label: '支払金額', key: 'product_id', _style:'min-width:80px' },
                { label: '支払い方法', key: 'product_name', _style:'min-width:150px;' },
                { label: '支払日', key: 'status', _style:'min-width:60px;' }
              ]"
      >
      </CDataTable>
      <template #footer>
        <span></span>
      </template>
    </CModal>
    <ImportDialog resourceName="import_recipes" />
    <ImportDialog resourceName="import_products" />
    <PasswordReissueDialog :resourceName="resourceName" />
  </v-container>
</template>

<script>
import ToolBar from "@/components/app/toolbar";
import FieldGenerator from "@/components/field/generator";
import utility from "@/utility";
import Breadcrumb from "@/components/app/breadcrumb";
import Datepicker from 'vuejs-datepicker'
import ImportDialog from "@/components/dialogs/csv-import-dialog";
import PasswordReissueDialog from "@/components/dialogs/password-reissue-dialog";
//日本語化
import {ja} from 'vuejs-datepicker/dist/locale'
import moment from 'moment';

export default {
  components: {
    ToolBar,
    Breadcrumb,
    FieldGenerator,
    Datepicker,
    ImportDialog,
    PasswordReissueDialog
  },
  props: {
    resourceName: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    pk: {
      type: String,
      required: true
    },
    breadcrumbs: {
      type: Array,
      default: () => []
    },
    disableImport: {
      type: Boolean,
      default: false
    },
    disableEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 公開切り替えモーダル関連
      publishModal: false,
      unPublishModal: false,
      DatePickerFormat: 'yyyy-MM-dd',
      ja:ja,
      targetDate: null,
      reservePublish: false,
      // 課金履歴モーダル
      condimentsModal: false,
    }
  },
  computed: {
    disableDates() {
      return {
        to: moment().toDate()
      }
    },
    entity() {
      return this.$store.getters[`${this.resourceName}/entity/entity`];
    },
    loading() {
      return this.$store.getters[`${this.resourceName}/entity/isLoading`];
    },
    loaded() {
      return this.$store.getters[`${this.resourceName}/entity/isLoaded`];
    },
    processing() {
      return this.$store.getters[`${this.resourceName}/entity/isProcessing`];
    },
    error() {
      return this.$store.getters[`${this.resourceName}/entity/error`];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    },
    showPublishButton(){
      if(this.resourceName !== 'recipes' && this.resourceName !== 'products'){
        return false;
      }

      return true;
    },
    showEditButton() {
      if (this.resourceName === 'requests' || this.resourceName === 'reminders') {
        return false;
      }

      if (this.resourceName === 'users') {
        return false;
      }

      return true;
    },
    showDeleteButton() {
      if (this.resourceName === 'requests' || this.resourceName === 'reminders') {
        return false;
      }

      if(this.resourceName === 'makers' && !this.isProvider){
        return false;
      }
/*
      if(this.resourceName === 'maker_administrators' && this.entity.maker_administrator_deleted === 1){
        return false;
      }

      if(this.resourceName === 'administrators' && this.entity.deleted === 1){
        return false;
      }
      */

      if(this.resourceName === 'templates' && this.entity.type === '1'){
        return false;
      }
/*
      if(this.resourceName === 'users' && this.entity.user_deleted === 1){
        return false;
      }*/

      if (this.resourceName === 'questionnaires') {
        return false;
      }

      return true;
    },
    showRestoreButton() {
      if(this.resourceName === 'maker_administrators'){
        return true;
      }

      if(this.resourceName === 'administrators'){
        return true;
      }

      if(this.resourceName === 'makers' && this.isProvider){
        return true;
      }

      if(this.resourceName === 'users'){
        return true;
      }

      if (this.resourceName === 'questionnaires') {
        return false;
      }

      return false;
    },
    disableRestoreButton() {
      if(this.resourceName === 'maker_administrators' && this.entity.maker_administrator_deleted !== 0){
        return false;
      }

      if(this.resourceName === 'administrators' && this.entity.deleted !== 0){
        return false;
      }

      if(this.resourceName === 'makers' && this.entity.maker_deleted !== 0 && this.isProvider){
        return false;
      }

      if(this.resourceName === 'users' && this.entity.user_deleted !== 0){
        return false;
      }

      return true;
    },
    showCheckMakerButton() {
      if (this.resourceName !== 'templates') {
        return false;
      }

      return this.isProvider;
    },
    isDisabledUpdateBtn() {
      if (this.resourceName === 'templates') {
        return this.isNotEditableTemplates();
      }

      return false;
    },
    isDisableDeleteButton() {
      if (this.resourceName === 'templates') {
        return this.entity.relation_count > 0;
      }

      if(this.resourceName === 'makers' && this.entity.maker_deleted === 1 && this.isProvider){
        return true;
      }

      if (this.resourceName === 'news') {
        return this.entity.published === 1;
      }

      if (this.resourceName === 'maker_administrators' && this.entity.maker_administrator_deleted === 1) {
        return true;
      }

      if (this.resourceName === 'administrators' && this.entity.deleted === 1) {
        return true;
      }

      if (this.resourceName === 'users' && this.entity.user_deleted === 1) {
        return true;
      }

      return false;
    },
    isDisabledCheckUnserBtn() {
      return !this.entity.review_set_id;
    }
  },
  methods: {
    onRefresh() {
      this.$store.dispatch(`${this.resourceName}/entity/show`, {
        pk: this.pk
      });
    },
    onEdit() {
      this.$router.push({path: `/${this.resourceName}/${this.pk}/edit`});
    },
    onBack() {
      this.$router.push({path: `/${this.resourceName}`});
    },
    onDelete() {
      if (
        (this.resourceName === 'users' && this.isProvider && !this.$store.getters["auth/permissionUserEdit"]) ||
        (this.resourceName === 'makers' && this.isProvider && !this.$store.getters["auth/permissionMakerEdit"])) {
        utility
          .$alert("編集権限がありません。", "エラー", {
            confirmButtonText: "OK",
            type: "error",
            center: true
          })
          .then(() => {
          });
      } else {
        let message = "削除しますか？";
        if (this.resourceName === 'products') {
          if (this.entity.recipe_id !== null) {
            message = "公開中の紐付きレシピがありますがよろしいですか？";
          }
        }
        utility
          .$confirm(message, "確認", {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true
          })
          .then(() => {
            this.$store
              .dispatch(`${this.resourceName}/entity/destroy`, {
                ids: [this.pk]
              })
              .then(() => {
                this.$router.push({path: `/${this.resourceName}`});
              }).catch(() => {
              if (this.resourceName === 'templates') {
                this.$router.push({path: `/${this.resourceName}`});
              }
            });
          });
      }
    },
    onRestore() {
      if (
        (this.resourceName === 'users' && this.isProvider && !this.$store.getters["auth/permissionUserEdit"]) ||
        (this.resourceName === 'makers' && this.isProvider && !this.$store.getters["auth/permissionMakerEdit"])) {
        utility
          .$alert("編集権限がありません。", "エラー", {
            confirmButtonText: "OK",
            type: "error",
            center: true
          })
          .then(() => {
          });
      } else {
        this.$store
          .dispatch(`${this.resourceName}/entity/restore`, {
            ids: [this.pk]
          })
          .then(() => {
            this.$router.push({path: `/${this.resourceName}`});
          });
      }
    },
    onCheckMaker() {
      this.$emit('check-maker', this.entity);
    },
    onCheckAnswer() {
      this.$router.push({path: `/answers/${this.entity.review_set_id}`});
    },
    publish(status) {
      this.publishModal = false;
      this.unPublishModal = false;
      this.$store
        .dispatch(`${this.resourceName}/list/publish`, {
          ids: [this.pk],
          status,
          makerIds: [this.entity.maker_id],
          reserve: this.reservePublish,
          date: this.targetDate != null ? moment(this.targetDate).format('YYYY-MM-DD') : null,
        })
        .then(() => {
          this.$router.push({path: `/${this.resourceName}`});
        });
    },
    onChangeReservePublish(value, obj) {
      this.reservePublish = value;
    },
    cancelPublish() {
      this.$store
        .dispatch(`${this.resourceName}/list/cancelPublish`, {
          ids: [this.pk]
        })
        .then(() => {
          this.$router.push({path: `/${this.resourceName}`});
        });
    },
    isNotEditableTemplates() {
      // 商品レビューセットは
      // レビューの回答が一つでもあったら編集不可
      return this.entity.result_count > 0;
    },
    openDialog(resource) {
      this.$store.commit(`import_${resource}/csv/open`);
    },
    openCondimentsModal() {
      // this.$store.dispatch(`${this.resourceName}/list/condiments`, {recipe_id})
      //   .then(() => {
      //   });
      this.condimentsModal = true;
    },
    onShowMakerRecipes() {
      this.$store.dispatch("filters/initialize");

      this.$store.commit("filters/add", {
        field: "maker_id",
        cond: "eq",
        value: this.pk,
        type: "select"
      });

      this.$store.dispatch("filters/preventInitialize");

      this.$router.push({path: `/recipes`});
    },
    onShowMakerProducts() {
      this.$store.dispatch("filters/initialize");

      this.$store.commit("filters/add", {
        field: "maker_id",
        cond: "eq",
        value: this.pk,
        type: "select"
      });

      this.$store.dispatch("filters/preventInitialize");

      this.$router.push({path: `/products`});
    },
    onShowMakerAdmins() {
      this.$store.dispatch("filters/initialize");

      this.$store.commit("filters/add", {
        field: "maker_id",
        cond: "eq",
        value: this.pk,
        type: "select"
      });

      this.$store.dispatch("filters/preventInitialize");

      this.$router.push({path: `/maker_administrators`});
    },
    onChangePassword() {
      this.$store.commit("passwordReissue/open", {id: this.pk});
    },
    moveToDownload(name) {
      this.$router.push({path: `/download_${name}/${this.pk}`});
    },
    moveToHistories() {
      this.$router.push({path: `/reminder_histories/${this.pk}`});
    },
    onSendReminder() {
      utility
        .$confirm('未回答のユーザにアンケート提出催促通知を送信します。よろしいですか。', "確認", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true
        })
        .then(() => {
          this.$store
            .dispatch(`${this.resourceName}/entity/reminder`, {
              id: this.pk
            })
            .then(() => {
              utility.$message({
                type: "success",
                message: "提出催促を送信しました",
                showClose: true,
                customClass: "el-message-content-position"
              });
            }).catch(() => {
          });
        });
    }
  },
  created() {
    this.$store.commit(`${this.resourceName}/entity/initialize`);
  },
  mounted() {
    this.$store.dispatch(`${this.resourceName}/entity/show`, {
      pk: this.pk
    });
  },
  watch: {
    loaded(value) {
      if (value && !Object.keys(this.entity).length) {
        // 存在しないIDなどの場合は一覧画面に遷移させる
        this.$router.push({path : `/${this.resourceName}`});
      }
    },
    "entity.large_category_id": {
      handler(value) {
        if (this.resourceName === "products" && this.entity.large_category_id !== null) {
          this.$store.dispatch(
            `common/product_medium_categories/options/index`,
            this.entity.large_category_id
          );
        }
      }
    }
  }
};
</script>

<style module lang="scss">
$base-app-header-height: 75px;
$base-header-height: 55px;
$base-footer-height: 60px;

.control-button{
  font-size: 0.875rem !important;
}

.control-button-s{
  font-size: 0.5rem !important;
}

.container.container {
  width: 100%;
  height: calc(100% - #{$base-app-header-height});
  padding: 0;
  position: relative;

  .container-header {
    height: $base-header-height !important;
  }

  .container-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: calc(100% - #{$base-header-height});
    overflow: hidden;

    .main-content {
      height: calc(
        100vh - #{$base-header-height} - #{$base-footer-height}
      );
      padding: 8px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .container-error {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      p {
        color: #ff0000;
        i {
          margin: 0 10px 0 0;
        }
        i,
        span {
          vertical-align: middle;
        }
      }
    }
  }

  .container-footer {
    height: $base-footer-height !important;
  }
}

.datepicker{
  div > input{
    border: 1px ridge #333333;
    display: block;
    margin: 5px 5px 10px;
  }
}
</style>
